import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MDButton from '@components/MDButton';
import DashboardLayout from '@examples/LayoutContainers/DashboardLayout';

interface Props {
    /// A primeira tela que o perfil libera: é o "início" de quem está logado.
    home: string;
}

/// Endereço inexistente: avisa, em vez de abrir a primeira tela e parecer um link válido.
export const NotFound = ({ home }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <DashboardLayout>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1.5,
                    minHeight: '70vh',
                    px: 3,
                    textAlign: 'center',
                }}
            >
                <SearchOffIcon sx={{ fontSize: 48, opacity: 0.5 }} />

                <Typography variant="h5" component="h1">
                    {t('naoEncontrada.titulo')}
                </Typography>

                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                    {t('naoEncontrada.ajuda')}
                </Typography>

                <MDButton variant="gradient" color="dark" onClick={() => navigate(home)} sx={{ mt: 1 }}>
                    {t('naoEncontrada.voltar')}
                </MDButton>
            </Box>
        </DashboardLayout>
    );
};
